import type { CustomerDocumentType, Mutation, MutationLoadCustomerDocumentArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { LOAD_CUSTOMER_DOCUMENT } from './gql/loadCustomerDocument';

type MutationDataType = Pick<Mutation, 'loadCustomerDocument'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('loadCustomerDocument');

type DocumentTypeType = 'DeliveryNote' | 'Invoice' | 'Refund';

export const useLoadCustomerDocument = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [loadCustomerDocument, { loading, error, data }] = useMutation<
        MutationDataType,
        MutationLoadCustomerDocumentArgs
    >(LOAD_CUSTOMER_DOCUMENT, {
        onError
    });

    const outgoingLoadCustomerDocument = useCallback(
        (documentNumber: string, documentType: DocumentTypeType) => {
            loadCustomerDocument({
                variables: { documentNumber, documentType: documentType as CustomerDocumentType }
            });
        },
        [loadCustomerDocument]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        loadCustomerDocument: outgoingLoadCustomerDocument,
        loading,
        response
    };
};
